<div class="desktop" *ngIf="isMobile === false  && isTablet === false">
  <router-outlet></router-outlet>
</div>
<div *ngIf="isMobile === true  || isTablet === true">
  <router-outlet></router-outlet>
</div>

<div class="desktop-cookies col-3" *ngIf="mostrarCookies && !masInfo && isMobile === false  && isTablet === false && cookies === null">
  <div class="column">
    <img src="assets/images/fad_logo_black.png" alt="">
  </div>
  <div class="column">
    <p class="title">
      FAD ® e cookies...
    </p>
    <p class="description">
      Este site utiliza cookies. Ao clicar em ACEITAR ou ao continuar a navegar no site, você está aceitando o uso de cookies.
    </p>
  </div>
  <div class="column">
    <div id="pop_terminos_aceptar" (click)="mostrarCookies = false" class="button">
      ACEITAR
    </div>
    <br>
    <p class="enlace" (click)="masInfo = true">MAIS INFORMAÇÕES...</p>
  </div>
</div>
<div class="desktop-cookies" *ngIf="mostrarCookies && masInfo && isMobile === false  && isTablet === false && cookies === null">
  <div class="column column-3">
    <p class="title" style="cursor: pointer; display:inline-block;" (click)="masInfo = false; mostrarCookies = true">
      < Voltar
    </p>
    <p class="description">
      Informamos que, quando você entra em nosso site, coletamos cookies, cookies são pequenos arquivos de texto criptografados que são encontrados em seu navegador, em nosso site eles ajudam o usuário a realizar certas funções como o método de pesquisa ou login, lembrando o nome de usuário e senha dentro seu navegador, lembrando os produtos do carrinho de compras, recomendando produtos ou serviços de acordo com seu perfil; Os cookies facilitam este processo de forma rápida e eficiente.
    </p>
    <div class="container">
      <p class="title">
        Os cookies que utilizamos são os seguintes:
      </p>
      <p class="description">
        Entrada do usuário, identificação, segurança do usuário, sessão de balanceamento de carga, plug-in, propriedade, sessão, análise, publicidade.
        <b>Você pode ativar e desativar os cookies através do seu navegador.</b>
      </p>
    </div>
    <div id="pop_terminos_aceptar_info" (click)="mostrarCookies = false" class="button complete">
      ACEITAR
    </div>
  </div>
</div>

<!-- FASIVO MOVIL -->

<div class="movil-cookies row-3" *ngIf="mostrarCookies && !masInfo && ( isMobile === true  || isTablet === true ) && cookies === null">
  <div class="column">
    <img src="assets/images/fad_logo_black.png" alt="">
  </div>
  <div class="column">
    <p class="title">
      FAD ® e cookies...
    </p>
    <p class="description">
      Este site utiliza cookies. Ao clicar em ACEITAR ou ao continuar a navegar no site, você está aceitando o uso de cookies.
    </p>
  </div>
  <div class="column">
    <div id="pop_terminos_aceptar_movil" (click)="mostrarCookies = false" class="button">
      ACEITAR
    </div>
    <br>
    <p class="enlace" (click)="masInfo = true">MAIS INFORMAÇÕES...</p>
  </div>
</div>

<div class="movil-cookies" *ngIf="mostrarCookies && masInfo && ( isMobile === true  || isTablet === true ) && cookies === null">
  <div class="column column-3">
    <p class="title" style="cursor: pointer; display:inline-block;" (click)="masInfo = false; mostrarCookies = true">
      < Voltar
    </p>
    <p class="description">
      Informamos que, quando você entra em nosso site, coletamos cookies, cookies são pequenos arquivos de texto criptografados que são encontrados em seu navegador, em nosso site eles ajudam o usuário a realizar certas funções como o método de pesquisa ou login, lembrando o nome de usuário e senha dentro seu navegador, lembrando os produtos do carrinho de compras, recomendando produtos ou serviços de acordo com seu perfil; Os cookies facilitam este processo de forma rápida e eficiente.
    </p>
    <div class="container">
      <p class="title">
        Os cookies que utilizamos são os seguintes:
      </p>
      <p class="description">
        Entrada do usuário, identificação, segurança do usuário, sessão de balanceamento de carga, plug-in, propriedade, sessão, análise, publicidade.
        <b>Você pode ativar e desativar os cookies através do seu navegador.</b>
      </p>
    </div>
    <div id="pop_terminos_aceptar_info_movil" (click)="mostrarCookies = false" class="button complete">
      ACEITAR
    </div>
  </div>
</div>

<div  *ngIf="loading">
  <div class="loader">
    <img class="" src="assets/images/loader_FAD.gif" alt="">
  </div>
</div>
